module.exports = __webpack_public_path__ + "static/media/Holly Lodge Wardrobes (8).489f3d55.JPG";